<template>
  <!--弹窗-->
    <el-dialog width="800px" :title="title" :visible.sync="visible" :before-close="handleClose" top="8vh">
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            height="500"
            ref="multipleTable"
            border
            style="width: 100%;min-height: calc(84vh - 208px);">
            <el-table-column
                label="变化数量"
                prop="change_num"
                width="80"
                align="center">
            </el-table-column>
            <el-table-column
                label="关键词数量上限"
                prop="keyword_limit"
                width="120"
                align="center">
            </el-table-column>
            <el-table-column
                label="描述"
                prop="message"
                min-width="150"
                align="center">
            </el-table-column>
            <el-table-column
                label="变化时间"
                prop="created_time"
                width="136"
                align="center">
            </el-table-column>
        </el-table>
        <el-row>
            <el-pagination
                background
                :current-page="query.page"
                :page-size="query.limit"
                style="float: right;margin-top: 20px; margin-bottom: 10px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[20, 50, 100, 200]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="query.total">
            </el-pagination>
        </el-row>
        
    </el-dialog>
</template>
<script>
import * as api from "@/api/Product/Product";
export default {
    data() {
        return {
            loading: false,
            query: {
                page: 1,
                limit: 20,
                total: 0
            },
            list: []
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        //获取列表数据
        async getList() {
            await api.get_keyword_sum_record(this.query).then(res => {
                if (res.code === 0) {
                    this.list = res.data.list;
                    this.query.total = res.data.total;
                }
            });
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        //分页
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        // 关闭弹窗
        handleClose() {
            this.$emit("close-callback", true);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
/deep/ ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-track-piece {
    background-color: #ffff;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:horizontal {
    width: 7px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
</style>
